import { Listing } from './listing.type';

export const getListingType = (
    listing: Listing
): 'premium' | 'featured' | undefined => {
    if (listing.isPremium) {
        return 'premium';
    }

    return;
};
